import React from 'react';
import { useTranslation } from 'react-i18next';

import { ResourceTitle } from '@/components/ResourceTitle/ResourceTitle';
import { useAppSelector } from '@/redux/store';

import { LeagueWinners } from '../LeagueWinners/LeagueWinners';

import AllParticipantsList from './AllParticipantsList/AllParticipantsList';
import BannerIndustry from './BannerIndustry';

const LeagueBoard: React.FC = () => {
  const { t } = useTranslation();
  const leagueBoard = useAppSelector((state) => state.leagues.leaderBoard);

  return (
    <div className="flex flex-col gap-[25px] mt-[24px]">
      <ResourceTitle className="isolate">{t('Leaderboard')}</ResourceTitle>
      <BannerIndustry />
      {leagueBoard && (
        <LeagueWinners
          list={leagueBoard.leaderBoard.filter(({ position }) => position < 4)}
        />
      )}
      {leagueBoard && leagueBoard.leaderBoard && (
        <AllParticipantsList
          array={leagueBoard.leaderBoard}
          nearbyUsers={leagueBoard.currentUserPosition?.users || undefined}
          userPosition={leagueBoard.currentUserPosition?.position || undefined}
        />
      )}
    </div>
  );
};

export default LeagueBoard;
